import Axios from 'axios';
import {ApiResultModel, IReferenceKey} from '../models/common.model';
import {
    TotalInquiryRequest,
    IInquiryResponse,
    RequestGetRequiredInquiry,
    ITotalInquiryResponse,
} from '../models/inquiry.model';
import {APIBASE_URL, INQUIRY} from '../config/cacheKey';

export const getrequiredInquiryList = (
    data: RequestGetRequiredInquiry
): Promise<IInquiryResponse> => {
    return Axios.post<ApiResultModel<IInquiryResponse>>(
        APIBASE_URL + INQUIRY + '/GetrequiredInquiryList',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const TotalInquiry = async (
    data: TotalInquiryRequest
): Promise<ApiResultModel<ITotalInquiryResponse>> => {
    return Axios.post<ApiResultModel<ITotalInquiryResponse>>(
        APIBASE_URL + INQUIRY + '/TotalInquiry',
        data
    ).then((result) => {
        return result.data;
    });
};

// to do
// export const SetOtpForInquiry = (data: ISetOtpForInquiryRequest):
//     Promise<IInquiryResponse> => {
//     return Axios.post<ApiResultModel<IInquiryResponse>>(
//         APIBASE_URL + INQUIRY + '/SetOtpForInquiry',
//         data
//     ).then((result) => {
//         return result.data.data;
//     });
// };
